import { render, staticRenderFns } from "./precise.vue?vue&type=template&id=47363070&scoped=true"
import script from "./precise.vue?vue&type=script&lang=js"
export * from "./precise.vue?vue&type=script&lang=js"
import style0 from "./precise.vue?vue&type=style&index=0&id=47363070&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47363070",
  null
  
)

export default component.exports